/* eslint-disable no-self-assign */
import produce from 'immer';
import _ from 'lodash';

const toFinite = (value, fallback = 0) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};
export function orderChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));
  const orient = parseInt(layer.orientation);
  const rotation = parseInt(layer.rotation);
  change.layerNo = layer.layerNo;
  change.quality = layer.quality;
  change.lamellaLength = layer.lamellaLength;
  change.lamellaThickness = layer.lamellaThickness;
  change.lamellaWidth = layer.lamellaWidth;
  change.rawThickness = layer.rawThickness;
  change.rawWidth = layer.rawWidth;
  change.widthoffset = layer.widthoffset != undefined && layer.widthoffset !== '' ? layer.widthoffset : [];
  /* CLT */
  if (!toServer.isKVH) {
    let layerMinTakeaway, /* layerMaxTakeaway, */ layerOversize, layerWidthOversize;
    try {
      if (settings !== undefined) {
        layerMinTakeaway = settings.minTakeaway;
        // layerMaxTakeaway = settings.maxTakeaway;
        layerOversize = settings.lOversize;
        layerWidthOversize = settings.qOversize;
      }
    } catch (e) {
      // parse error
    }

    const minTakeAway = !isNaN(layerMinTakeaway) ? layerMinTakeaway : 5; // mm
    const boardWidth = layer.rawWidth;
    const panelWidth = parseFloat(toServer.panelWidth);
    const panelLength = parseFloat(toServer.panelLength);
    const oversize = !isNaN(layerOversize) && !force ? parseFloat(layerOversize) : parseFloat(toServer.oversize);
    const oversizeWidth = !isNaN(layerWidthOversize) && !force ? parseFloat(layerWidthOversize) : parseFloat(toServer.oversizeWidth);
    let boards = 0;
    let panelDimension = -1;

    // console.log('VALS: ', minTakeAway, boardWidth, panelWidth, panelLength, oversize, oversizeWidth);
    if (orient == 1) {
      // L
      panelDimension = panelWidth + oversize;
    }
    if (orient == 2) {
      // Q
      panelDimension = panelLength + oversizeWidth;
    }

    const boardPlanedMinWidth = boardWidth - minTakeAway;
    boards = Math.ceil(panelDimension / boardPlanedMinWidth);
    const takeaway = boardWidth - panelDimension / boards;
    // console.log('takeaway: ', boardWidth, panelDimension, boards);

    // qtakeaway
    /* for (var i = minTakeAway; i <= maxTakeAway; i++) {
      var iWidth = boardWidth - (i/10);

      var numberOfBoards = panelDimension/iWidth;
      var diff = Math.abs(Math.ceil(numberOfBoards) - numberOfBoards)*i;
      var odiff = Math.abs((Math.ceil(numberOfBoards)*i)/1000);

      if ((diff+odiff) < waste) {
        boards = Math.ceil(numberOfBoards);
        takeaway = (i/10);
        waste = diff;
      }
    } */

    let width = boardWidth - takeaway;
    width = Math.round(width * 100) / 100;
    const number_of_lamellas = boards;

    /* L - LONG */
    if (orient == 1) {
      const lamellaLength = toServer.panelLength;
      if (width > 0) {
        change.lamellaWidth = width;
        change.numOfLamellas = number_of_lamellas;
        change.lamellaLength = lamellaLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 1;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    } else if (orient == 2) {
      /* Q - CROSS */
      const lamellaLength = toServer.panelWidth;
      if (width > 0) {
        change.lamellaWidth = width;
        change.numOfLamellas = number_of_lamellas;
        change.lamellaLength = lamellaLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 2;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    }

    if (rotation !== undefined) {
      change.rotation = rotation;
    } else {
      change.rotation = layer.rotation;
    }

    // arboreal
    if (isNaN(change.rotation)) {
      change.rotation = 0;
    }

    change.orientation = orient;
    if (index >= 0) {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.item[form.childFieldName][index] = change;
        })
      );
    } else {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.newChild = change;
        })
      );
    }
  }
}

function applyLayerDefaultsRigidply(change, index, toServer) {
  if (isNaN(parseInt(change.layerNo, 10))) {
    change.layerNo = typeof index === 'number' && index >= 0 ? index + 1 : change.layerNo;
  }

  if (toServer?.woodType || toServer?.species) {
    change.woodType = toServer.woodType || toServer.species;
  }
  if (toServer?.lamellaWidth != null) {
    change.lamellaWidth = toServer.lamellaWidth;
  }
  if (toServer?.rawThickness != null) {
    change.rawThickness = toServer.rawThickness;
  }
  if (toServer?.rawWidth != null) {
    change.rawWidth = toServer.rawWidth;
  }

  if ((change.lamellaThickness == '' || change.lamellaThickness == '0' || change.lamellaThickness == 0) && toServer?.lamellaThickness != null) {
    change.lamellaThickness = toServer.lamellaThickness;
  }

  if (
    !Array.isArray(change.beamWidths) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length == 0) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length > 0 && Math.abs(Number(change.beamWidths[0].rawLamellaWidth) - Number(toServer?.rawWidth)) > 0.5) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length > 0 && Math.abs(Number(change.beamWidths[0].lamellaWidth) - Number(toServer?.lamellaWidth)) > 0.5) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length > 0 && Math.abs(change.beamWidths[0].lamellaThickness - toServer?.lamellaThickness) > 0.5)
  ) {
    change.beamWidths = [
      {
        lamellaThickness: change.lamellaThickness,
        lamellaWidth: toServer?.lamellaWidth,
        rawLamellaThickness: toServer?.rawThickness,
        rawLamellaWidth: toServer?.rawWidth
      }
    ];
  }
}

function applyLayerDefaultsFournier(change, index, toServer) {
  if (isNaN(parseInt(change.layerNo, 10))) {
    change.layerNo = typeof index === 'number' && index >= 0 ? index + 1 : change.layerNo;
  }

  // if (toServer?.woodType || toServer?.species) {
  //   change.woodType = toServer.woodType || toServer.species;
  // }
  // if (toServer?.lamellaWidth != null) {
  //   change.lamellaWidth = toServer.lamellaWidth;
  // }
  // if (toServer?.rawThickness != null) {
  //   change.rawThickness = toServer.rawThickness;
  // }
  // if (toServer?.rawWidth != null) {
  //   change.rawWidth = toServer.rawWidth;
  // }

  if ((change.lamellaThickness == '' || change.lamellaThickness == '0' || change.lamellaThickness == 0) && toServer?.lamellaThickness != null) {
    change.lamellaThickness = toServer.lamellaThickness;
  }

  if (
    !Array.isArray(change.beamWidths) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length == 0) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length > 0 && Math.abs(Number(change.beamWidths[0].rawLamellaWidth) - Number(toServer?.rawWidth)) > 0.5) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length > 0 && Math.abs(Number(change.beamWidths[0].lamellaWidth) - Number(toServer?.lamellaWidth)) > 0.5) ||
    (Array.isArray(change.beamWidths) && change.beamWidths.length > 0 && Math.abs(change.beamWidths[0].lamellaThickness - toServer?.lamellaThickness) > 0.5)
  ) {
    change.beamWidths = [
      {
        lamellaThickness: change.lamellaThickness,
        lamellaWidth: toServer?.lamellaWidth,
        rawLamellaThickness: toServer?.rawThickness,
        rawLamellaWidth: toServer?.rawWidth
      }
    ];
  }
}

// function renumberAndSyncLayers(draft, childFieldName) {
//   const layers = draft?.item?.[childFieldName] || [];
//   const total = layers.length;

//   draft.item.numberOfLayers = total;

//   const parentRawThickness = draft.item?.rawThickness;
//   const parentRawWidth = draft.item?.rawWidth;

//   layers.forEach((l, i) => {
//     l.layerNo = i + 1;

//     if ((l.rawThickness === '' || l.rawThickness == null) && parentRawThickness != null) {
//       l.rawThickness = parentRawThickness;
//     }
//     if ((l.rawWidth === '' || l.rawWidth == null) && parentRawWidth != null) {
//       l.rawWidth = parentRawWidth;
//     }
//   });
// }

export function arborealMaterialCodeCalculator(form, formState, changeModelState) {
  const change = JSON.parse(JSON.stringify(formState));
  if (change.planningNumber > 4 || change.planningNumber % 2 != 0) {
    // lahko je 0, 2 ali 4, vse ostalo vrže na 0
    change.planningNumber = 0;
  }

  let quality = change.quality;
  if (change.quality.length == 1) {
    // N -> NN
    quality = change.quality + change.quality;
  }

  change.materialCode =
    'FIN-' +
    change.strengthString +
    '-' +
    quality +
    '-C' +
    change.planningNumber +
    '-0' +
    change.rawThickness +
    'X' +
    change.rawWidth +
    'X' +
    change.lamellaLength +
    '-' +
    change.treatment +
    '-' +
    change.woodType;

  changeModelState((prevNewState) =>
    produce(prevNewState, (draft) => {
      draft.item = change;
    })
  );
}

export function schneiderModelCalculator(form, formState, changeModelState) {
  const change = JSON.parse(JSON.stringify(formState));
  changeModelState((prevNewState) =>
    produce(prevNewState, (draft) => {
      draft.item = change;
    })
  );
}

export function schneiderChildCalculator(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));

  change.woodType = _.get(toServer, 'woodType', '');
  change.quality = _.get(toServer, 'quality', '');

  if (index >= 0) {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.item[form.childFieldName][index] = change;
      })
    );
  } else {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.newChild = change;
      })
    );
  }
}

export function vudlandeModelCalculator(form, formState, changeModelState) {
  const change = JSON.parse(JSON.stringify(formState));
  for (const o of change?.sorted_output || []) {
    if (o?.frommTopCorner || o?.frommBottomCorner) {
      o.withFromm = true;
    }

    if (o?.withFromm) {
      o.withFromm3 = true;
    }

    if (o?.frommFilmInput || o?.frommFilOutput) {
      o.withFromm2 = true;
    }

    if (o?.fromm3TopCorner) {
      o.withFromm3 = true;
    }
  }
  changeModelState((prevNewState) =>
    produce(prevNewState, (draft) => {
      draft.item = change;
    })
  );
}

// Same Fromm cascade as vudlande
export function spearheadSortedOrderCalculator(form, formState, changeModelState) {
  const change = JSON.parse(JSON.stringify(formState));
  for (const o of change?.sorted_output || []) {
    if (o?.frommTopCorner || o?.frommBottomCorner) {
      o.withFromm = true;
    }

    if (o?.withFromm) {
      o.withFromm3 = true;
    }

    if (o?.frommFilmInput || o?.frommFilOutput) {
      o.withFromm2 = true;
    }

    if (o?.fromm3TopCorner) {
      o.withFromm3 = true;
    }
  }
  changeModelState((prevNewState) =>
    produce(prevNewState, (draft) => {
      draft.item = change;
    })
  );
}

/*
 * Runs on Confirm, after the operator has finished typing, which no calculator sees.
 * sorted_output is required by the serializer and the modal swallows the 400, so without a row
 * Confirm looks dead. Build one from the order and carry the order-level Quality into it, since
 * that is what picks the etage. Quality itself is not a SortedOrder column, so it is dropped.
 */
export function spearheadSortedOrderSaveTransform(item) {
  const out = { ...item };
  const quality = out.quality != null ? String(out.quality).trim() : '';
  delete out.quality;

  const isNew = out.id == null || out.id === 0;
  if (isNew && !out.createdDate) {
    out.createdDate = new Date().toISOString();
  }
  // EditView starts every new item as 'todo', which spearhead's Q. Sorting has no tab for
  if (isNew) {
    out.status = 'ready';
  }

  if (!out.sorted_output || out.sorted_output.length === 0) {
    out.sorted_output = [
      {
        articleNumber: out.number || '',
        quality,
        lamellaThickness: out.lamellaThickness || 0,
        lamellaWidth: out.lamellaWidth || 0,
        rawLamellaThickness: out.rawLamellaThickness || 0,
        rawLamellaWidth: out.rawLamellaWidth || 0,
        lamellaLength: parseFloat(out.lengths) || 0,
        layers: out.numberOfLayers || 0,
        piecesPerLayer: out.piecesPerLayer || 0
      }
    ];
  } else if (quality) {
    out.sorted_output = out.sorted_output.map((row, i) => (i === 0 && !row.quality ? { ...row, quality } : row));
  }

  return out;
}

export function schilligerChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  // console.log('schilligerChildCalculateValues: ', form, layer, toServer, settings);
  // console.log('schilligerChildCalculateValues layer: ', layer);
  // console.log('schilligerChildCalculateValues toServer: ', toServer);

  const change = JSON.parse(JSON.stringify(layer));
  const orient = parseInt(layer.orientation);
  const rotation = parseInt(layer.rotation);

  const LAMELLA_WIDTH = 100;
  // const INSULATION_WIDTH = 262.5;

  change.layerNo = layer.layerNo;
  change.quality = layer.quality;
  change.lamellaLength = layer.lamellaLength;
  change.lamellaThickness = layer.lamellaThickness;
  change.lamellaWidth = layer.lamellaWidth;
  change.rawThickness = layer.rawThickness;
  change.rawWidth = layer.rawWidth;
  change.widthoffset = layer.widthoffset != undefined && layer.widthoffset !== '' ? layer.widthoffset : [];

  /* CLT */
  if (!toServer.isKVH) {
    let layerMinTakeaway, /* layerMaxTakeaway, */ layerOversize, layerWidthOversize;
    try {
      if (settings !== undefined) {
        layerMinTakeaway = settings.minTakeaway;
        // layerMaxTakeaway = settings.maxTakeaway;
        layerOversize = settings.lOversize;
        layerWidthOversize = settings.qOversize;
      }
    } catch (e) {
      // parse error
    }

    const minTakeAway = !isNaN(layerMinTakeaway) ? layerMinTakeaway : 5; // mm
    const boardWidth = layer.rawWidth;
    const panelWidth = parseFloat(toServer.panelWidth);
    const panelLength = parseFloat(toServer.panelLength);
    const oversize = !isNaN(layerOversize) && !force ? parseFloat(layerOversize) : parseFloat(toServer.oversize);
    const oversizeWidth = !isNaN(layerWidthOversize) && !force ? parseFloat(layerWidthOversize) : parseFloat(toServer.oversizeWidth);
    let boards = 0;
    let panelDimension = -1;

    // console.log('schilligerChildCalculateValues VALS: ', minTakeAway, boardWidth, panelWidth, panelLength, oversize, oversizeWidth);
    if (orient == 1) {
      // L
      panelDimension = panelWidth + oversizeWidth;
    } else if (orient == 5) {
      // LTH
      panelDimension = panelWidth;
    } else if (orient == 6) {
      // M
      panelDimension = panelWidth;
    }

    if (orient == 2) {
      // Q
      panelDimension = panelLength + oversize;
    } else if (orient == 4) {
      // QTH
      panelDimension = panelLength;
    }

    // console.log('schilligerChildCalculateValues panelDimension: ', panelDimension, ' for orient.: ', orient);

    const boardPlanedMinWidth = boardWidth - minTakeAway;
    boards = Math.ceil(panelDimension / boardPlanedMinWidth);
    const takeaway = boardWidth - panelDimension / boards;

    let width = boardWidth - takeaway;
    width = Math.round(width * 100) / 100;
    const number_of_lamellas = boards;

    // VALIDATOR TEST
    const layerData = calculateWoodIns(layer, toServer);
    // console.log('schilligerChildCalculateValues layerData: ', layerData);

    /* L - LONG */
    if (orient == 1) {
      const lamellaLength = toServer.panelLength;
      if (width > 0) {
        change.lamellaWidth = width;
        change.numOfLamellas = number_of_lamellas;
        change.numOfLamellasWood = number_of_lamellas;
        change.numOfLamellasIns = 0;
        change.lamellaLength = lamellaLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 1;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    } else if (orient == 5) {
      /* LTH - LONG THERM */
      const lamellaLength = toServer.panelLength;
      if (width > 0) {
        // console.log('LTH - LONG THERM');
        change.lamellaWidth = LAMELLA_WIDTH;
        // change.lamellaWidth = width;
        change.numOfLamellas = calculateWoodIns(layer, toServer).trueCount + calculateWoodIns(layer, toServer).falseCount;
        change.numOfLamellasWood = layerData?.trueCount;
        change.numOfLamellasIns = layerData?.falseCount;
        change.lamellaLength = lamellaLength;
        change.oversize = 0;
        change.oversizeWidth = change.oversizeWidth;
        change.orientation = 5;
        change.widthoffset = change.widthoffset;
        change.panelWidth = toServer.panelWidth;
        change.panelLength = toServer.panelLength;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    } else if (orient == 2) {
      /* Q - CROSS */
      const lamellaLength = toServer.panelWidth;
      if (width > 0) {
        change.lamellaWidth = width;
        change.numOfLamellas = number_of_lamellas;
        change.numOfLamellasIns = 0;
        change.lamellaLength = lamellaLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 2;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    } else if (orient == 4) {
      /* Q - CROSS THERM */
      const lamellaLength = toServer.panelWidth;
      if (width > 0) {
        change.lamellaWidth = parseFloat((calculateWoodIns(layer, toServer)?.woodWidth || 0).toFixed(2));
        // change.numOfLamellas = number_of_lamellas;
        change.numOfLamellas = calculateWoodIns(layer, toServer).trueCount + calculateWoodIns(layer, toServer).falseCount;
        change.numOfLamellasWood = calculateWoodIns(layer, toServer).trueCount;
        change.numOfLamellasIns = calculateWoodIns(layer, toServer).falseCount;
        change.lamellaLength = lamellaLength;
        change.oversize = 0;
        change.oversizeWidth = change.oversizeWidth;
        change.orientation = 4;
        change.panelWidth = toServer.panelWidth;
        change.panelLength = toServer.panelLength;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    } else if (orient == 6) {
      // LengthOffset
      const lamellaLength = toServer.panelLength;
      if (width > 0) {
        change.lamellaWidth = parseFloat((calculateWoodIns(layer, toServer)?.woodWidth || 0).toFixed(2));
        change.numOfLamellas = calculateLengthOffset(layer);
        change.numOfLamellasWood = calculateWoodIns(layer, toServer).trueCount;
        change.numOfLamellasIns = calculateWoodIns(layer, toServer).falseCount;
        change.lamellaLength = lamellaLength;
        change.panelWidth = toServer.panelWidth;
        change.panelLength = toServer.panelLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 1;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    }
    if (rotation !== undefined) {
      change.rotation = rotation;
    } else {
      change.rotation = layer.rotation;
    }

    // arboreal
    if (isNaN(change.rotation)) {
      change.rotation = 0;
    }

    change.orientation = orient;
    if (index >= 0) {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.item[form.childFieldName][index] = change;
        })
      );
    } else {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.newChild = change;
        })
      );
    }
  }
}

export function lehmannChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));
  const orient = parseInt(layer.orientation);
  const rotation = parseInt(layer.rotation);

  const toNum = (v, fallback = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };

  const buildWoodHollowSequence = (offsets, totalSize) => {
    const result = [];

    const sorted = Array.isArray(offsets)
      ? offsets
          .map((o) => ({
            offset: toNum(o.offset),
            width: toNum(o.width),
            identifier: o.identifier
          }))
          .filter((o) => o.width > 0)
          .sort((a, b) => a.offset - b.offset)
      : [];

    let pos = 0;

    sorted.forEach((o) => {
      if (o.offset > pos) {
        result.push({
          wood: false,
          offset: pos,
          position: pos,
          width: o.offset - pos
        });
      }

      result.push({
        wood: true,
        offset: o.offset,
        position: o.offset,
        width: o.width,
        identifier: o.identifier
      });

      pos = o.offset + o.width;
    });

    if (pos < totalSize) {
      result.push({
        wood: false,
        offset: pos,
        position: pos,
        width: totalSize - pos
      });
    }

    return result;
  };

  change.layerNo = layer.layerNo;
  change.quality = layer.quality;

  change.lamellaLength = layer.lamellaLength;
  change.lamellaThickness = layer.lamellaThickness;
  change.lamellaWidth = layer.lamellaWidth;

  change.rawThickness = layer.rawThickness;
  change.rawWidth = layer.rawWidth;

  change.widthoffset = layer.widthoffset !== undefined && layer.widthoffset !== '' ? layer.widthoffset : [];
  change.lengthoffset = layer.lengthoffset !== undefined && layer.lengthoffset !== '' ? layer.lengthoffset : [];
  change.lengthoffsetWidth = layer.lengthoffsetWidth;

  if (!toServer.isKVH) {
    let layerMinTakeaway;
    let layerOversize;
    let layerWidthOversize;

    try {
      if (settings !== undefined) {
        layerMinTakeaway = settings.minTakeaway;
        layerOversize = settings.lOversize;
        layerWidthOversize = settings.qOversize;
      }
    } catch (e) {
      // parse error
    }

    const minTakeAway = !isNaN(layerMinTakeaway) ? layerMinTakeaway : 5;
    const boardWidth = parseFloat(layer.rawWidth);
    const panelWidth = parseFloat(toServer.panelWidth);
    const panelLength = parseFloat(toServer.panelLength);

    const oversize = !isNaN(layerOversize) && !force ? parseFloat(layerOversize) : parseFloat(toServer.oversize);
    const oversizeWidth = !isNaN(layerWidthOversize) && !force ? parseFloat(layerWidthOversize) : parseFloat(toServer.oversizeWidth);

    let panelDimension = -1;

    if (orient === 1) {
      panelDimension = panelWidth + oversizeWidth;
    } else if (orient === 2) {
      panelDimension = panelLength + oversize;
    } else if (orient === 4) {
      panelDimension = panelLength;
    } else if (orient === 5) {
      panelDimension = panelWidth;
    } else if (orient === 6 || orient === 7) {
      panelDimension = panelWidth;
    }

    const boardPlanedMinWidth = boardWidth - minTakeAway;
    const boards = boardPlanedMinWidth > 0 ? Math.ceil(panelDimension / boardPlanedMinWidth) : 0;
    const takeaway = boards > 0 ? boardWidth - panelDimension / boards : 0;

    let width = boardWidth - takeaway;
    width = Math.round(width * 100) / 100;

    const number_of_lamellas = boards;
    const layerData = calculateWoodIns(layer, toServer);

    if (orient === 1) {
      const lamellaLength = panelLength;

      if (width > 0) {
        change.lamellaWidth = width;
        change.numOfLamellas = number_of_lamellas;
        change.numOfLamellasWood = number_of_lamellas;
        change.numOfLamellasIns = 0;
        change.lamellaLength = lamellaLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 1;
      }
    } else if (orient === 2) {
      const lamellaLength = panelWidth;

      if (width > 0) {
        change.lamellaWidth = width;
        change.numOfLamellas = number_of_lamellas;
        change.numOfLamellasWood = number_of_lamellas;
        change.numOfLamellasIns = 0;
        change.lamellaLength = lamellaLength;
        change.oversize = oversize;
        change.oversizeWidth = oversizeWidth;
        change.orientation = 2;
      }
    } else if (orient === 7 || orient === 8) {
      const plannedWidth = parseFloat(layer.lengthoffsetWidth || layer.lamellaWidth || layer.rawWidth || 126);

      if (plannedWidth > 0) {
        const widthOffsets = Array.isArray(layer.widthoffset) ? layer.widthoffset : [];
        const lengthOffsets = Array.isArray(layer.lengthoffset) ? layer.lengthoffset : [];

        const llMultipieceData = buildWoodHollowSequence(lengthOffsets, panelLength);
        const clMultipieceData = buildWoodHollowSequence(widthOffsets, panelWidth);

        change.orientation = orient;

        // editable/source offsets
        change.widthoffset = widthOffsets;
        change.lengthoffset = lengthOffsets;

        // generated simulation / PLC-style data
        change.llMultipieceData = llMultipieceData;
        change.clMultipieceData = clMultipieceData;

        change.lamellaWidth = plannedWidth;
        change.rawWidth = layer.rawWidth || plannedWidth;
        change.lengthoffsetWidth = plannedWidth;

        change.lamellaLength = panelLength;
        change.panelWidth = panelWidth;
        change.panelLength = panelLength;

        change.oversize = 0;
        change.oversizeWidth = 0;

        // visible grid members only: wood ribs from both directions
        change.numOfLamellas = widthOffsets.length + lengthOffsets.length;
        change.numOfLamellasWood = change.numOfLamellas;
        change.numOfLamellasIns = 0;
      } else {
        change.lamellaWidth = '';
        change.numOfLamellas = '';
        change.lamellaLength = '';
        change.oversize = '';
        change.oversizeWidth = '';
        change.orientation = '';
      }
    }

    change.rotation = isNaN(rotation) ? 0 : rotation;

    if (index >= 0) {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.item[form.childFieldName][index] = change;
        })
      );
    } else {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.newChild = change;
        })
      );
    }
  }
}

function calculateCleverRobotLamellaCount(layer) {
  const widthCount = Array.isArray(layer.widthoffset) ? layer.widthoffset.length : 0;
  const lengthCount = Array.isArray(layer.lengthoffset) ? layer.lengthoffset.length : 0;

  return widthCount + lengthCount;
}

export function smartlamPlanerSetupCalculator(form, item, changeModelState) {
  const change = JSON.parse(JSON.stringify(item));
  try {
    const width = parseFloat(item.rawWidth);
    const plannedWidth = parseFloat(item.lamellaPlannedWidth);
    const diff = plannedWidth - width;

    change.W1Takeaway = Math.abs(diff) / 2;
    change.W3Takeaway = Math.abs(diff) / 2;

    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.item = change;
      })
    );
  } catch (e) {
    console.log(e);
  }
}

export function peetriOrderCalculator(form, formState, changeModelState) {
  const change = JSON.parse(JSON.stringify(formState));

  change.error = false; // če lahko potrdimo edit ordera, pomeni, da ni več validator errorjev
  changeModelState((prevNewState) =>
    produce(prevNewState, (draft) => {
      draft.item = change;
    })
  );
}

export function rigidplyInitCalculator(form, formState, changeModelState) {
  return changeModelState((prev) =>
    produce(prev, (draft) => {
      if (!draft.item) draft.item = {};
      if (draft.item.manualEntry !== true) {
        draft.item.manualEntry = true;
      }
    })
  );
}

export function rigidplyChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));
  const layerNo = _.get(layer, 'layerNo', '');
  if (layerNo == '') change.layerNo = typeof index === 'number' && index >= 0 ? index + 1 : '';

  change.layerNo = layer.layerNo;
  applyLayerDefaultsRigidply(change, index, toServer);

  /* BSH */
  const topT = parseInt(_.get(layer, 'topTension', 0));
  const crown = parseInt(_.get(layer, 'crown', 0));
  const topN1D = parseInt(_.get(layer, 'topN1D', 0));
  const coreN1M = parseInt(_.get(layer, 'coreN1M', 0));
  const coreN2M = parseInt(_.get(layer, 'coreN2M', 0));
  const bottomN1D = parseInt(_.get(layer, 'bottomN1D', 0));
  const bottomTension = parseInt(_.get(layer, 'bottomTension', 0));
  const multiplier = Array.isArray(layer.beamWidths) && layer.beamWidths.length >= 1 ? layer.beamWidths.length : 1;
  change.numOfLamellas = (topT + crown + topN1D + coreN1M + coreN2M + bottomN1D + bottomTension) * multiplier;
  // change.splitWood = parseInt(change.splitThickness) > 0;

  if (index >= 0) {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.item[form.childFieldName][index] = change;
      })
    );
  } else {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.newChild = change;
      })
    );
  }
}

export function fournierChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));
  const layerNo = _.get(layer, 'layerNo', '');
  if (layerNo == '') change.layerNo = typeof index === 'number' && index >= 0 ? index + 1 : '';

  change.layerNo = layer.layerNo;
  applyLayerDefaultsFournier(change, index, toServer);

  /* BSH */
  const topT = parseInt(_.get(layer, 'topTension', 0));
  const crown = parseInt(_.get(layer, 'crown', 0));
  const topN1D = parseInt(_.get(layer, 'topN1D', 0));
  const coreN1M = parseInt(_.get(layer, 'coreN1M', 0));
  const coreN2M = parseInt(_.get(layer, 'coreN2M', 0));
  const bottomN1D = parseInt(_.get(layer, 'bottomN1D', 0));
  const bottomTension = parseInt(_.get(layer, 'bottomTension', 0));
  const multiplier = Array.isArray(layer.beamWidths) && layer.beamWidths.length >= 1 ? layer.beamWidths.length : 1;
  change.numOfLamellas = (topT + crown + topN1D + coreN1M + coreN2M + bottomN1D + bottomTension) * multiplier;
  // change.splitWood = parseInt(change.splitThickness) > 0;

  if (index >= 0) {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.item[form.childFieldName][index] = change;
      })
    );
  } else {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.newChild = change;
      })
    );
  }
}

export function peetriChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));
  const orient = parseInt(layer.orientation);
  const rotation = parseInt(layer.rotation);

  // const LAMELLA_WIDTH = 100;
  // const INSULATION_WIDTH = 262.5;

  change.layerNo = layer.layerNo;
  change.quality = layer.quality;
  change.lamellaLength = layer.lamellaLength;
  change.lamellaThickness = layer.lamellaThickness;
  change.lamellaWidth = layer.lamellaWidth;
  change.rawThickness = layer.rawThickness;
  change.rawWidth = layer.rawWidth;
  change.insPlannedWidth = 0;
  if (orient != 5) {
    change.insRawWidth = 0;
  }
  // change.widthoffset = layer.widthoffset != undefined && layer.widthoffset !== '' ? layer.widthoffset : [];

  /* CLT */
  if (!toServer.isKVH) {
    let layerMinTakeaway, /* layerMaxTakeaway, */ layerOversize, layerWidthOversize;
    try {
      if (settings !== undefined) {
        layerMinTakeaway = settings.minTakeaway;
        // layerMaxTakeaway = settings.maxTakeaway;
        layerOversize = settings.lOversize;
        layerWidthOversize = settings.qOversize;
      }
    } catch (e) {
      // parse error
    }

    const minTakeAway = !isNaN(layerMinTakeaway) ? layerMinTakeaway : 0; // mm
    const boardWidth = layer.rawWidth;
    const panelWidth = parseFloat(toServer.panelWidth);
    const panelLength = parseFloat(toServer.panelLength);
    const oversize = !isNaN(layerOversize) && !force ? parseFloat(layerOversize) : parseFloat(toServer.oversize);
    const oversizeWidth = !isNaN(layerWidthOversize) && !force ? parseFloat(layerWidthOversize) : parseFloat(toServer.oversizeWidth);
    let boards = 0;
    let panelDimension = -1;
    let specialWidth = 0;

    // console.log('schilligerChildCalculateValues VALS: ', minTakeAway, boardWidth, panelWidth, panelLength, oversize, oversizeWidth);
    if (orient == 1) {
      // L
      panelDimension = panelWidth + oversize;
    } else if (orient == 5) {
      // LTH
      panelDimension = panelWidth + oversize;
    } else if (orient == 6) {
      // M
      panelDimension = panelWidth;
    }

    if (orient == 2) {
      // Q
      panelDimension = panelLength + oversizeWidth;
    } else if (orient == 4) {
      // QTH
      panelDimension = panelLength;
    }

    // console.log('schilligerChildCalculateValues panelDimension: ', panelDimension, ' for orient.: ', orient);

    const boardPlanedMinWidth = boardWidth - minTakeAway;
    boards = Math.ceil(panelDimension / boardPlanedMinWidth);
    const takeaway = boardWidth - panelDimension / boards;

    let width = boardWidth - takeaway;
    width = Math.round(width * 100) / 100;
    const number_of_lamellas = boards;

    if (takeaway > settings.maxTakeaway) {
      change.lamellaWidth = width + '- max takeaway ERROR';
    } else if (takeaway < settings.minTakeAway) {
      change.lamellaWidth = width + '- min takeaway ERROR';
    } else {
      /* L - LONG */
      if (orient == 1) {
        const lamellaLength = Math.round(toServer.panelLength);
        if (width > 0) {
          change.lamellaWidth = width;
          change.numOfLamellas = number_of_lamellas;
          change.numOfLamellasWood = number_of_lamellas;
          change.numOfLamellasIns = 0;
          change.lamellaLength = lamellaLength;
          change.oversize = oversize;
          change.oversizeWidth = oversizeWidth;
          change.orientation = 1;
        } else {
          change.lamellaWidth = '';
          change.numOfLamellas = '';
          change.lamellaLength = '';
          change.oversize = '';
          change.oversizeWidth = '';
          change.orientation = '';
        }
      } else if (orient == 5) {
        /* LTH - LONG THERM */
        const lamellaLength = Math.round(toServer.panelLength);
        if (width > 0) {
          change.widthoffset.map((o) => {
            if (typeof o.width === 'string') {
              // TODO maybe
              // če je string, pomeni, da je blo ročno editano => prilagodi širino navadnih lamel na novo širino special lamel
              console.log('SPECIAL LAMELLA CHANGE - recalculate normal lamellas accordingly');
            }
          });
          change.lamellaWidth = width;
          change.numOfLamellasIns = 2;
          if (width < settings.specialLayerUpperLimit) {
            change.numOfLamellasWood = number_of_lamellas - 3;
          } else {
            change.numOfLamellasWood = number_of_lamellas - 1;
          }
          change.numOfLamellas = change.numOfLamellasWood;
          change.lamellaLength = lamellaLength;
          change.oversize = 0;
          change.orientation = 5;
          change.panelWidth = toServer.panelWidth;
          change.panelLength = toServer.panelLength;
          // specialLamella rawWidth
          specialWidth = (panelDimension - change.numOfLamellasWood * width) / 2;
          specialWidth = Math.round(specialWidth * 100) / 100;

          change.widthoffset.map((o, idx) => {
            o.width = specialWidth;
            o.offset = idx * (change.numOfLamellas * width + specialWidth); // prvi: 0, drugi: panelDimension - specialWidth
          });
          change.insPlannedWidth = specialWidth;
          // SPECIAL LAMELA OPOZORILA
          if (change.insRawWidth - specialWidth > settings.maxTakeaway || change.insRawWidth - specialWidth < settings.minTakeaway) {
            change.insPlannedWidth = change.insPlannedWidth + '- takeaway ERROR';
          }
          console.log('change ins L', change);
        } else {
          change.lamellaWidth = '';
          change.numOfLamellas = '';
          change.lamellaLength = '';
          change.oversize = '';
          change.oversizeWidth = '';
          change.orientation = '';
        }
      } else if (orient == 2) {
        /* Q - CROSS */
        const lamellaLength = Math.round(toServer.panelWidth);
        if (width > 0) {
          change.lamellaWidth = width;
          change.numOfLamellas = number_of_lamellas;
          change.numOfLamellasIns = 0;
          change.lamellaLength = lamellaLength;
          change.oversize = oversize;
          change.oversizeWidth = oversizeWidth;
          change.orientation = 2;
        } else {
          change.lamellaWidth = '';
          change.numOfLamellas = '';
          change.lamellaLength = '';
          change.oversize = '';
          change.oversizeWidth = '';
          change.orientation = '';
        }
      }
    }

    if (rotation !== undefined) {
      change.rotation = rotation;
    } else {
      change.rotation = layer.rotation;
    }

    // arboreal
    if (isNaN(change.rotation)) {
      change.rotation = 0;
    }

    change.orientation = orient;
    if (index >= 0) {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.item[form.childFieldName][index] = change;
        })
      );
    } else {
      changeModelState((prevNewState) =>
        produce(prevNewState, (draft) => {
          draft.newChild = change;
        })
      );
    }
  }
}

function calculateWoodIns(l, o) {
  // console.log('calculateWoodIns');
  let error = false;
  if (l !== null && o !== null) {
    const lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset != undefined) {
      var sortedWidthOffset = l.widthoffset.slice().sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lamellaWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          const woff = sortedWidthOffset[i];
          const woodWidth = woff.offset - lastOffset;
          const woodLamellas = Math.round(woodWidth / l.lamellaWidth);
          const woodDiff = woodWidth - woodLamellas * l.lamellaWidth;
          error = woodDiff != 0;
          const widthoffsetLamellas = Math.round(woff.width / l.lamellaWidth);

          // console.log('widthoffsetLamellas: ', widthoffsetLamellas, ' = ', woff.width, ' / ', l.lamellaWidth);
          // console.log('schilliger calculateWoodIns: ', i + ' ' + l.lamellaWidth + ' ' + woff.offset + ' ' + woff.width + ' ' + woodLamellas + ' ' + widthoffsetLamellas);
          lastOffset = woff.offset + woff.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false);
        }
      }
    }
    // Calculate first lamella width
    const firstNumberOfLamellas = Math.round(sortedWidthOffset[0]?.offset / l.rawWidth);
    const actualLamellaPlannedWidth = sortedWidthOffset[0]?.offset / firstNumberOfLamellas;

    if (l.lamellaWidth > 0) {
      const endDimension = l.orientation === 4 || l.orientation === 2 ? o.panelLength : o.panelWidth;
      const woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }
    let trueCount = 0;
    let falseCount = 0;

    lamellas.forEach((element) => {
      if (element === true) {
        trueCount++;
      } else {
        falseCount++;
      }
    });
    // console.log('# calculateWoodIns lamellas: ', lamellas);
    return { trueCount, falseCount, error, woodWidth: actualLamellaPlannedWidth };
  }
}

function calculateLengthOffset(l) {
  if (l !== null) {
    const lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset != undefined) {
      var sortedWidthOffset = l.widthoffset.slice().sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lengthoffsetWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          const woff = sortedWidthOffset[i];
          const woodWidth = woff.offset - lastOffset;
          const woodLamellas = Math.round(woodWidth / l.lengthoffsetWidth);
          const widthoffsetLamellas = Math.round(woff.width / l.lengthoffsetWidth);

          // console.log('schilliger calculateWoodIns: ', i + ' ' + ins.offset + ' ' + ins.width + ' ' + woodLamellas + ' ' + widthoffsetLamellas);
          lastOffset = woff.offset + woff.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false);
        }
      }
    }
    // console.log('DEBUG 3');

    // finish or if a normal layer

    if (l.lamellaWidth > 0) {
      const endDimension = l.orientation === 4 || l.orientation === 2 ? l.panelLength : l.panelWidth;
      const woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }

    return lamellas.length;
  }
}

export function widthOffsetMaterial(l, props) {
  if (!l) return;

  const { formState, settings } = props;
  const { orientation, widthoffset, lamellaLength, lengthoffsetWidth, rawWidth, lamellaWidth, panelWidth } = l;

  const panelDimension = parseInt(orientation) === 6 ? panelWidth : formState.item.panelLength;
  let actualLamellaPlannedWidth = orientation === 6 ? lengthoffsetWidth : lamellaLength;

  if (widthoffset && widthoffset.length > 0) {
    // Sort widthoffset by offset
    const sortedWidthOffset = widthoffset.slice().sort((a, b) => a.offset - b.offset);

    const insulationWidth = sortedWidthOffset.reduce((total, current) => total + current.width, 0);
    // const woodWidth = calculateWoodWidth(sortedWidthOffset, panelDimension);

    // Calculate first lamella width
    const firstNumberOfLamellas = Math.round(sortedWidthOffset[0].offset / rawWidth);
    actualLamellaPlannedWidth = sortedWidthOffset[0].offset / firstNumberOfLamellas;

    const lengthWithoutInsulation = panelDimension - insulationWidth;
    const qLamellaNum = calculateLamellaNum(lengthWithoutInsulation, actualLamellaPlannedWidth, orientation, lamellaWidth, settings);
    const qInsLamellaNum = Math.ceil(insulationWidth / settings.insulationWidthF);

    return {
      qLamellaNum,
      qInsLamellaNum,
      woodWidth: actualLamellaPlannedWidth,
      insWidth: settings.insulationWidthF,
      error: false
    };
  }
}

// function calculateWoodWidth(sortedWidthOffset, panelDimension) {
//   let woodWidth = 0;

//   for (let i = 0; i < sortedWidthOffset.length; i++) {
//     if (i === 0) {
//       woodWidth += sortedWidthOffset[i].offset;
//     } else if (i < sortedWidthOffset.length - 1) {
//       woodWidth += sortedWidthOffset[i + 1].offset - (sortedWidthOffset[i].offset + sortedWidthOffset[i].width);
//     } else {
//       woodWidth += panelDimension - (sortedWidthOffset[i].offset + sortedWidthOffset[0].width);
//     }
//   }

//   return woodWidth;
// }

function calculateLamellaNum(lengthWithoutInsulation, actualLamellaPlannedWidth, orientation, lamellaWidth, settings) {
  if (orientation === 4) {
    return Math.ceil(lengthWithoutInsulation / actualLamellaPlannedWidth);
  } else {
    return Math.ceil((lengthWithoutInsulation + settings.qOversize) / (lamellaWidth - settings.minTakeaway));
  }
}

export function lengthOffsetMaterial(l) {
  if (l !== null) {
    const lamellas = [];
    let lastOffset = 0;
    if (l.widthoffset !== undefined) {
      var sortedWidthOffset = l.widthoffset.slice().sort((a, b) => a.offset - b.offset);

      if (sortedWidthOffset.length > 0 && l.lengthoffsetWidth > 0) {
        for (let i = 0; i < sortedWidthOffset.length; i++) {
          const woff = sortedWidthOffset[i];
          const woodWidth = woff.offset - lastOffset;
          const woodLamellas = Math.round(woodWidth / l.lengthoffsetWidth);
          const widthoffsetLamellas = Math.round(woff.width / l.lengthoffsetWidth);

          lastOffset = woff.offset + woff.width;
          for (let j = 0; j < woodLamellas; j++) lamellas.push(true); // Wood lamellas
          for (let j = 0; j < widthoffsetLamellas; j++) lamellas.push(false); // Insulation (or width offset) lamellas
        }
      }
    }

    if (l.lamellaWidth > 0) {
      const endDimension = l.orientation === 4 || l.orientation === 2 ? l.panelLength : l.panelWidth;
      const woodLamellas = Math.round((endDimension - lastOffset) / l.lamellaWidth);
      for (let j = 0; j < woodLamellas; j++) lamellas.push(true);
    }

    // Count the number of false values
    const falseCount = lamellas.filter((lamella) => lamella === false).length;

    return { shortCount: falseCount * l.lengthoffset.length, shortWidth: l.lengthoffsetWidth };
  }
}

function normalizeNumericField(target, key, aliases = []) {
  const candidates = [target[key], ...aliases.map((alias) => target[alias])];
  for (const candidate of candidates) {
    const num = Number(candidate);
    if (Number.isFinite(num)) {
      target[key] = num;
      return;
    }
  }
}

export function lehmannBshChildCalculateValues(form, layer, index, force, changeModelState, toServer, settings) {
  const change = JSON.parse(JSON.stringify(layer));
  const compositionKeys = ['bottomTension', 'bottomN1D', 'coreN2M', 'topN1D', 'topTension'];

  normalizeNumericField(change, 'lamellaThickness', ['lamella_thickness']);
  normalizeNumericField(change, 'lamellaWidth', ['lamella_width']);
  normalizeNumericField(change, 'lamellaLength', ['lamella_length']);
  normalizeNumericField(change, 'beams', ['smartlam_f_product', 'beams']);
  normalizeNumericField(change, 'numOfLamellas', ['num_of_lamellas']);

  compositionKeys.forEach((key) => {
    const snakeKey = key.replace(/[A-Z]/g, (m) => `_${m.toLowerCase()}`);
    normalizeNumericField(change, key, [snakeKey]);
  });

  const resolvedBeamWidth = Array.isArray(change?.beamWidth) ? change.beamWidth : Array.isArray(change?.beam_width) ? change.beam_width : [];

  change.beamWidth = resolvedBeamWidth
    .map((entry) => (typeof entry === 'object' ? entry.width ?? entry.value ?? entry : entry))
    .map((val) => Number(val))
    .filter(Number.isFinite);

  if (!change.beamWidth.length && Number.isFinite(change.lamellaWidth)) {
    change.beamWidth = [change.lamellaWidth];
  }

  const multiplier = change.beamWidth?.length > 0 ? change.beamWidth.length : 1;
  const compositionSum = compositionKeys.reduce((sum, key) => sum + toFinite(change[key], 0), 0);

  if (compositionSum > 0) {
    change.numOfLamellas = compositionSum * multiplier;
  }

  if (index >= 0) {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.item[form.childFieldName][index] = change;
      })
    );
  } else {
    changeModelState((prevNewState) =>
      produce(prevNewState, (draft) => {
        draft.newChild = change;
      })
    );
  }
}

export function lehmannBshModelInitCalculator(form, formState, changeModelState) {
  return changeModelState((prev) =>
    produce(prev, (draft) => {
      const layers = _.get(draft, 'item.layers', []);
      layers.forEach((layer) => {
        if (Array.isArray(layer?.beamWidth)) {
          layer.beamWidth = layer.beamWidth
            .map((entry) => (typeof entry === 'object' ? entry.width ?? entry.value ?? entry : entry))
            .map((val) => Number(val))
            .filter(Number.isFinite);
        } else if (Number.isFinite(layer?.lamellaWidth)) {
          layer.beamWidth = [Number(layer.lamellaWidth)];
        }

        if (layer?.beams == null && Array.isArray(layer?.beamWidth)) {
          layer.beams = layer.beamWidth.length;
        }
      });
    })
  );
}
